import {
    FURUI_SUBMIT_FRUI_QPGOODS_BEGIN,
    FURUI_SUBMIT_FRUI_QPGOODS_SUCCESS,
    FURUI_SUBMIT_FRUI_QPGOODS_FAILURE,
    FURUI_SUBMIT_FRUI_QPGOODS_DISMISS_ERROR,
} from './constants';
import request from '../../../utils/request'

export function submitFrui_qpgoods(params) {
    return (dispatch) => { // optionally you can have getState as the second argument
      dispatch({
        type: FURUI_SUBMIT_FRUI_QPGOODS_BEGIN,
      });
  
      let apiurl = '/api/b/frui_qpgoods/add';
    
    if (params.id != undefined){
      apiurl = '/api/b/frui_qpgoods/update';
    }

    const promise = new Promise((resolve, reject) => {
        request({
          method:'post',
          url:apiurl,
          data: params,
        }).then( data => {
            dispatch({
                type: FURUI_SUBMIT_FRUI_QPGOODS_SUCCESS,
                data: data,
            });
            resolve(data);
        }).catch (error => {
            dispatch({
              type: FURUI_SUBMIT_FRUI_QPGOODS_FAILURE,
              data: { error: error },
            });
            reject(error);
        })
    });
  
      return promise;
    };
  }
  
  // Async action saves request error by default, this method is used to dismiss the error info.
  // If you don't want errors to be saved in Redux store, just ignore this method.
  export function dismissSubmitFrui_qpgoodsError() {
    return {
      type: FURUI_SUBMIT_FRUI_QPGOODS_DISMISS_ERROR,
    };
  }
  
  export function reducer(state, action) {
    switch (action.type) {
      case FURUI_SUBMIT_FRUI_QPGOODS_BEGIN:
        // Just after a request is sent
        return {
          ...state,
          submitFrui_qpgoodsPending: true,
          submitFrui_qpgoodsError: null,
        };
  
      case FURUI_SUBMIT_FRUI_QPGOODS_SUCCESS:
        // The request is success
        return {
          ...state,
          submitFrui_qpgoodsPending: false,
          submitFrui_qpgoodsError: null,
        };
  
      case FURUI_SUBMIT_FRUI_QPGOODS_FAILURE:
        // The request is failed
        return {
          ...state,
          submitFrui_qpgoodsPending: false,
          submitFrui_qpgoodsError: action.data.error,
        };
  
      case FURUI_SUBMIT_FRUI_QPGOODS_DISMISS_ERROR:
        // Dismiss the request failure error
        return {
          ...state,
          submitFrui_qpgoodsError: null,
        };
  
      default:
        return state;
    }
  }
  


// WEBPACK FOOTER //
// ./src/features/furui/redux/submitFrui_qpgoods.js